Array.prototype.flatMap = function(lambda) {
    return Array.prototype.concat.apply([], this.map(lambda));
};

function sum(values) {
    return values.reduce(function (a, b) {
        return a + Number(b);
    }, 0);
}

function avg(values) {
    return sum(values) / values.length;
}


function inverter(datasheet) {
    var data = datasheet.map(function (set) {
        return set.inverter.efficiency.result;
    });

    return (100 - avg(data)).toFixed(2);
}

function temperature(temperatureDerating) {
    return (100 - avg(temperatureDerating)).toFixed(2);
}

function soiling(datasheet) {
    var data = datasheet.flatMap(function (system) {
        return system.panels.map(function (panel) {
            return panel.inputs.data.losses.soiling;
        });
    });

    return (avg(data) * 100).toFixed(2);
}

function dc(datasheet) {
    var data = datasheet.flatMap(function (system) {
        return system.panels.map(function (panel) {
            return panel.inputs.data.losses.dc;
        });
    });

    return (avg(data) * 100).toFixed(2);
}

function ac(datasheet) {
    var data = datasheet.flatMap(function (system) {
        return system.panels.map(function (panel) {
            return panel.inputs.data.losses.ac;
        });
    });

    return (avg(data) * 100).toFixed(2);
}

function buildTable(output, node) {
    var table =  document.createElement('table');
    var tbody =  document.createElement('tbody');
    table.classList.add('table', 'table--auto', 'table--border');
    table.appendChild(tbody);
    node.appendChild(table);

    output.forEach(function (row) {
        var tr = document.createElement('tr');
        var label =  document.createElement('td');
        var value =  document.createElement('td');
        label.innerHTML = row.label;
        value.innerHTML = row.value;

        tr.appendChild(label);
        tr.appendChild(value);
        tbody.appendChild(tr);
    });
}


(function () {
    var node =  document.querySelector('#average-losses');

    if (!node) return;

    var datasheet = JSON.parse(node.dataset.datasheet);
    var temperatureDerating = JSON.parse(node.dataset.temperature);

    var output = [
        {
            label: 'Inverter',
            value: inverter(datasheet) + '%'
        },
        {
            label: 'Temperature',
            value: temperature(temperatureDerating) + '%'
        },
        {
            label: 'Soiling',
            value: soiling(datasheet) + '%'
        },
        {
            label: 'DC',
            value: dc(datasheet) + '%'
        },
        {
            label: 'AC',
            value: ac(datasheet) + '%'
        }
    ];

    buildTable(output, node);
})();
